import { CFG } from '../config'

export default class FilteringToggle {
  constructor(container) {
    this.container = container
    this.lists = container.querySelector('.wks-filtering__lists')
    if (!this.lists) return

    this.allItems = [...this.lists.querySelectorAll('.wks-filtering-list')]
    this.moreLi = this.allItems.find(li => li.querySelector('[data-js="more"]'))
    if (!this.moreLi) return

    this.moreBtn = this.moreLi.querySelector('[data-js="more"]')
    this.filterItems = this.allItems.filter(li => li !== this.moreLi)

    this.expanded = false
    this.mq = window.matchMedia(`(min-width: ${CFG.breakpoint}px)`)

    this.moreBtn.addEventListener('click', () => this.toggle())

    this.calculate()

    let resizeTimer
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer)
      resizeTimer = setTimeout(() => {
        if (!this.expanded) this.calculate()
      }, 150)
    })
  }

  calculate() {
    // 全アイテムを表示してから計測
    this.filterItems.forEach(li => {
      li.hidden = false
    })
    this.moreLi.hidden = true

    const maxRows = this.mq.matches ? 1 : 3

    // offsetTopで行を判定
    const rows = []
    let currentRowIndex = -1
    let lastTop = -Infinity

    this.filterItems.forEach(li => {
      const top = li.offsetTop
      if (top > lastTop) {
        currentRowIndex++
        lastTop = top
        rows[currentRowIndex] = []
      }
      rows[currentRowIndex].push(li)
    })

    // 全て収まる場合はmoreボタン不要
    if (rows.length <= maxRows) {
      this.moreLi.hidden = true
      return
    }

    // maxRows以降のアイテムを非表示
    for (let r = maxRows; r < rows.length; r++) {
      rows[r].forEach(li => {
        li.hidden = true
      })
    }

    // moreボタンを表示
    this.moreLi.hidden = false

    // moreボタンが最終行に収まるか確認
    const lastVisibleRow = rows[maxRows - 1]
    const lastVisibleItem = lastVisibleRow[lastVisibleRow.length - 1]
    const lastRowTop = lastVisibleItem.offsetTop
    const moreTop = this.moreLi.offsetTop

    if (moreTop > lastRowTop) {
      // moreボタンが次の行に溢れた → 最終行の末尾アイテムを1つずつ隠す
      for (let i = lastVisibleRow.length - 1; i >= 0; i--) {
        lastVisibleRow[i].hidden = true
        if (this.moreLi.offsetTop <= lastRowTop) break
      }
    }
  }

  toggle() {
    this.expanded = !this.expanded

    if (this.expanded) {
      this.filterItems.forEach(li => {
        li.hidden = false
      })
      this.moreLi.hidden = true
      this.container.dataset.expanded = 'true'
    } else {
      this.container.dataset.expanded = 'false'
      this.calculate()
    }
  }
}
